import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowLeft, BookOpen, Loader2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import { getSessionToken } from "@/utils/auth";

const BACKEND = window.APP_CONFIG?.BACKEND_URL || process.env.REACT_APP_BACKEND_URL || window.location.origin;
const API = `${BACKEND}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${getSessionToken()}` } });

export default function TechPlaybook() {
  const navigate = useNavigate();
  const [content, setContent] = useState(null);
  const [meta, setMeta] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/tech-assist/playbook`, auth())
      .then((r) => { setContent(r.data.content); setMeta(r.data); })
      .catch(() => { setContent(""); toast.error("Couldn't load the playbook"); });
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await axios.put(`${API}/tech-assist/playbook`, { content }, auth());
      setMeta(data);
      toast.success("Playbook saved. Tech Assist uses it right away.");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Couldn't save");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-50">
      <Header />
      <div className="max-w-3xl mx-auto px-4 py-5 space-y-4">
        <button onClick={() => navigate("/settings")} data-testid="back-to-settings" className="flex items-center gap-1 text-sm text-zinc-600 hover:text-zinc-900">
          <ArrowLeft className="w-4 h-4" /> Back to Settings
        </button>
        <div>
          <h1 className="text-xl font-bold text-zinc-900 flex items-center gap-2"><BookOpen className="w-6 h-6 text-[#207024]" /> Tech Playbook</h1>
          <p className="text-xs text-zinc-500 mt-1">Policies Tech Assist may quote to techs (payment terms, warranties, scheduling rules…). If it isn't written here or in the pricebook, Tech Assist sends the question to the office.</p>
        </div>
        {content === null ? (
          <div className="flex justify-center py-10"><Loader2 className="w-6 h-6 animate-spin text-[#207024]" /></div>
        ) : (
          <>
            <textarea value={content} onChange={(e) => setContent(e.target.value)} rows={22} data-testid="playbook-textarea"
              placeholder="Paste your Tech Playbook here…"
              className="w-full rounded-xl border-2 border-zinc-200 p-3 text-sm font-mono focus:border-[#207024] focus:outline-none bg-white" />
            <div className="flex items-center justify-between">
              <span className="text-[11px] text-zinc-500" data-testid="playbook-meta">
                {meta.updated_at ? `Last saved ${new Date(meta.updated_at).toLocaleString()} by ${meta.updated_by}` : "Not saved yet"} · {content.length.toLocaleString()} / 50,000 chars
              </span>
              <button onClick={save} disabled={saving} data-testid="playbook-save-btn"
                className="h-10 px-5 rounded-lg bg-[#207024] text-white font-semibold disabled:opacity-50">{saving ? "Saving…" : "Save playbook"}</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
